// extracted by mini-css-extract-plugin
module.exports = {"BrandsList":"style_BrandsList__22uea","BrandsList_list":"style_BrandsList_list__T4QfG"};